// extracted by mini-css-extract-plugin
export default {"cartList":"CartList_cartList__+P1tR"};